import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NumberInput from "./Reusable/NumberInput";
import React from "react";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { fetchRemoveItemFromCart } from "../actions/global";
import { formattedPrice } from "../utils";
import i18next from "i18next";
import { useDispatch } from "react-redux";
import { formatCoffeeType, formatSizeLabel } from "../utils/cellRenderTable";

const CartPageItem = ({ item }) => {
  const dispatch = useDispatch();

  const unitPrice = item?.discount ? item?.discountPrice : item?.price;

  const removeItemFromCart = (item) => {
    dispatch(fetchRemoveItemFromCart(item?.id));
  };

  return (
    <tr>
      <td className="image-content-cart-item-name">
        <div className="image-content-cart-item-name-holder">
          <img src={item?.image} className="img-fluid" alt="Fuka" />
          <h5>{item?.name}</h5>
        </div>
      </td>
      <td className="text-end mobile-width-column">
        {item?.productType == "COFFEE" && (
          <div className="mobile-width-column">
            {formatCoffeeType(item?.coffeeType)}
          </div>
        )}
      </td>
      <td className="text-end mobile-width-column">
        {item?.size != "DEFAULT" && item?.size && (
          <div className="mobile-width-column">
            {formatSizeLabel(item?.size)}
          </div>
        )}
      </td>
      <td className="text-end mobile-width-column">
        <div className="mobile-width-column">{item?.grinding}</div>
      </td>
      <td className="text-end mobile-width-column">
        <div className="mobile-width-column">
          {formattedPrice(unitPrice)} RSD
        </div>
      </td>
      <td className="text-end">{item?.quantity}</td>
      <td className="table-cart-item-subtotal">
        <div className="mobile-width-column">
          {formattedPrice(item?.quantity * unitPrice)} RSD
        </div>
      </td>
      <td
        className="table-cart-item-remove"
        onClick={() => removeItemFromCart(item)}
      >
        <FontAwesomeIcon icon={faClose} />
      </td>
    </tr>
  );
};

export default CartPageItem;
